// extracted by mini-css-extract-plugin
export default {"verificationCode":"verificationCode-cim37q","isSending":"isSending-OxCxJu","verInput":"verInput-vg0xIn"};